import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Col, Row, Button, Label, Input, Table } from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { v4 as uuidv4 } from "uuid";

function ArticulosKitCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_LINEAS = process.env.REACT_APP_URL_LINEAS;
  const URL_MARCAS = process.env.REACT_APP_URL_MARCAS;
  const URL_FAMILIAS = process.env.REACT_APP_URL_FAMILIAS;
  const URL_UNIDADES_NEGOCIO = process.env.REACT_APP_URL_UNIDADES_NEGOCIO;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const URL_COMPONENTES_KIT =
    process.env.REACT_APP_URL_COMPONENTES_KIT ||
    `${process.env.REACT_APP_URL_ARTICULOS}`.replace(
      /\/articulos\/?$/i,
      "/componentesKit"
    );
  const URL_ARMAR = `${URL_COMPONENTES_KIT}Armar`;

  const headers = {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  };

  const [nombre, setNombre] = useState("");
  const [SKU, setSKU] = useState("");
  const [MLM, setMLM] = useState("NA");
  const [medida, setMedida] = useState("NA");
  const [venta, setVenta] = useState(0);
  const [observaciones, setObservaciones] = useState("KIT");
  const [skuManual, setSkuManual] = useState(false);

  const [articulos, setArticulos] = useState([]);
  const [areas, setAreas] = useState([]);
  // Armado inicial: opcional, si se llena se arman kits al terminar de crearlo
  const [selectedArea, setSelectedArea] = useState("");
  const [cantidadArmar, setCantidadArmar] = useState(0);
  const [lineas, setLineas] = useState([]);
  const [marcas, setMarcas] = useState([]);

  const [selectedLinea, setSelectedLinea] = useState("");
  const [selectedMarca, setSelectedMarca] = useState("");
  const [selectedFamilia, setSelectedFamilia] = useState("");
  const [selectedUnidadNegocio, setSelectedUnidadNegocio] = useState("");
  const [selectedProveedor, setSelectedProveedor] = useState("");

  const [validaBoton, setValidaBoton] = useState(true);

  // Los componentes se capturan antes de guardar; se mandan al final
  const [inputFields, setInputFields] = useState([
    { id: uuidv4(), articulo: null, cantidad: 1 },
  ]);

  // SKU del kit: KIT + 3 letras del nombre + medida
  const generarSKU = (nombre, medida) => {
    const limpiar = (txt) =>
      (txt || "")
        .replace(/\s+/g, "")
        .replace(/[áàäâÁ]/g, "a")
        .replace(/[éèëêÉ]/g, "e")
        .replace(/[íìïîÍ]/g, "i")
        .replace(/[óòöôÓ]/g, "o")
        .replace(/[úùüûÚ]/g, "u")
        .toUpperCase();
    return `KIT${limpiar(nombre).substring(0, 3)}${limpiar(medida)}`;
  };

  useEffect(() => {
    if (skuManual) return;
    setSKU(generarSKU(nombre, medida));
  }, [nombre, medida, skuManual]);

  useEffect(() => {
    axios.get(URL_ARTICULOS, { headers }).then((r) => setArticulos(r.data || []));
    axios.get(URL_LINEAS, { headers }).then((r) => setLineas(r.data || []));
    axios.get(URL_MARCAS, { headers }).then((r) => setMarcas(r.data || []));
    axios.get(URL_AREAS, { headers }).then((r) => setAreas(r.data || []));
    axios.get(URL_FAMILIAS, { headers }).then((r) => {
      if (r.data?.[0]) setSelectedFamilia(r.data[0]._id);
    });
    axios.get(URL_UNIDADES_NEGOCIO, { headers }).then((r) => {
      if (r.data?.[0]) setSelectedUnidadNegocio(r.data[0]._id);
    });
    axios.get(`${URL_PROVEEDORES}Tipo/China`, { headers }).then((r) => {
      if (r.data?.[0]) setSelectedProveedor(r.data[0]._id);
    });
  }, []);

  const opciones = articulos.map((a) => ({
    ...a,
    junta: `${a.SKU || ""} ${a.nombre || ""}`,
  }));

  const handleAddFields = () => {
    setInputFields([...inputFields, { id: uuidv4(), articulo: null, cantidad: 1 }]);
  };

  const handleRemoveFields = (id) => {
    setInputFields(inputFields.filter((i) => i.id !== id));
  };

  const handleChangeArticulo = (id, sel) => {
    setInputFields(
      inputFields.map((i) => (i.id === id ? { ...i, articulo: sel } : i))
    );
  };

  const handleChangeCantidad = (id, valor) => {
    setInputFields(
      inputFields.map((i) => (i.id === id ? { ...i, cantidad: valor } : i))
    );
  };

  const saveKit = async (event) => {
    event.preventDefault();

    if (!nombre || !selectedLinea || !selectedMarca) {
      Swal.fire({
        icon: "error",
        title: "Faltan campos",
        text: "Nombre, Línea y Marca son obligatorios.",
      });
      return;
    }

    const renglones = inputFields.filter(
      (i) => i.articulo && parseFloat(i.cantidad) > 0
    );
    if (renglones.length === 0) {
      Swal.fire({
        icon: "error",
        title: "Faltan componentes",
        text: "Un kit necesita al menos un componente con cantidad.",
      });
      return;
    }

    // Un mismo articulo no puede ir dos veces: se capturaria dos veces su consumo
    const ids = renglones.map((r) => String(r.articulo._id));
    if (new Set(ids).size !== ids.length) {
      Swal.fire({
        icon: "error",
        title: "Componente repetido",
        text: "Hay un artículo capturado más de una vez. Súmalo en un solo renglón.",
      });
      return;
    }

    setValidaBoton(false);

    let articuloCreado = null;
    try {
      const skuFinal = SKU || "NA";
      const resp = await axios.post(
        URL_ARTICULOS,
        {
          codigo: skuFinal,
          codigoSAT: "NA",
          medida: medida || "NA",
          nombre,
          modelo: "KIT",
          piezasPorCaja: 1,
          costoUSD: 0,
          costoCNY: 0,
          costoMX: 0,
          venta: parseFloat(venta) || 0,
          observaciones: observaciones || "KIT",
          EAN: "NA",
          SKU: skuFinal,
          SKUBase: skuFinal,
          MLM: MLM || "NA",
          ASIN: "NA",
          ASINAntiguo: "NA",
          imagenes: "NA",
          linkML: "NA",
          linkShein: "NA",
          linkAmazon: "NA",
          linkCoppel: "NA",
          linkLiverpool: "NA",
          linkWalmart: "NA",
          linkElektra: "NA",
          cargadoML: "NA",
          cargadoShein: "NA",
          cargadoAmazon: "NA",
          cargadoCoppel: "NA",
          cargadoWalmart: "NA",
          cargadoLiverpool: "NA",
          cargadoElektra: "NA",
          largoProducto: 0,
          anchoProducto: 0,
          altoProducto: 0,
          pesoProducto: 0,
          largoEmpaque: 0,
          anchoEmpaque: 0,
          altoEmpaque: 0,
          pesoEmpaque: 0,
          largoMaster: 0,
          anchoMaster: 0,
          altoMaster: 0,
          pesoMaster: 0,
          stockMinimo: 0,
          stockMaximo: 0,
          indiceRotacion: 0,
          lineas: selectedLinea,
          marcas: selectedMarca,
          familias: selectedFamilia,
          unidadesNegocio: selectedUnidadNegocio,
          proveedores: selectedProveedor,
          especiales: "No",
          articuloPadre: null,
          esKit: "Si",
          lista1: 0,
          lista2: 0,
          lista3: 0,
          lista4: 0,
          lista1Bruto: 0,
          lista2Bruto: 0,
          lista3Bruto: 0,
          lista4Bruto: 0,
          comision: 0,
          otrosCostos: 0,
          ingresoPromedioNeto: 0,
          ingresoPromedioBruto: 0,
        },
        { headers }
      );
      articuloCreado = resp.data;

      for (const r of renglones) {
        await axios.post(
          URL_COMPONENTES_KIT,
          {
            articulos: articuloCreado._id,
            componentes: r.articulo._id,
            cantidad: parseFloat(r.cantidad),
          },
          { headers }
        );
      }

      // Armado inicial opcional: descuenta componentes y da de alta el kit
      let armados = 0;
      if (selectedArea && parseFloat(cantidadArmar) > 0) {
        const { data } = await axios.post(
          URL_ARMAR,
          {
            articulos: articuloCreado._id,
            cantidad: parseFloat(cantidadArmar),
            areas: selectedArea,
          },
          { headers }
        );
        armados = data.enInventario;
      }

      await axios.post(
        URL_LOGS,
        {
          tipo: "Crear Kit",
          detalle: `${nombre} ${skuFinal} (${renglones.length} componentes)${
            armados ? ` / armados ${cantidadArmar}` : ""
          }`,
          user: user.id,
        },
        { headers }
      );

      Swal.fire({
        icon: "success",
        title: "Kit creado",
        html: armados
          ? `<b>${skuFinal}</b><br>Se armaron ${cantidadArmar} y quedaron <b>${armados}</b> en inventario.`
          : `<b>${skuFinal}</b><br>Todavía no hay kits armados. Ármalos desde la pantalla de Kits.`,
      });
      setTimeout(() => (window.location.href = "/ComponentesKit"), 1000);
    } catch (error) {
      // Si el articulo se creo pero fallaron los componentes queda un kit vacio:
      // se da de baja para no dejarlo colgado
      if (articuloCreado?._id) {
        try {
          await axios.patch(
            `${URL_ARTICULOS}/${articuloCreado._id}`,
            { is_active: "No", esKit: "No" },
            { headers }
          );
        } catch (e) {
          console.log(e);
        }
      }
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "No se pudo crear el kit.",
        footer: `${
          error?.response?.data?.message ||
          error?.response?.data ||
          error.message ||
          ""
        }`,
      });
      setValidaBoton(true);
    }
  };

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_articulos ? (
        <div className="card container col-10">
          <h3 align="center">Nuevo Kit</h3>
          <p style={{ textAlign: "center", color: "#666" }}>
            Un kit es un artículo que se vende como uno solo pero consume varios.
            No tiene inventario propio: lo que se puede vender sale de lo que
            alcanza de sus componentes.
          </p>
          <br />

          <Row>
            <Col md={6}>
              <Label>Nombre *</Label>
              <Input
                type="text"
                placeholder="Nombre del kit"
                value={nombre}
                required
                onChange={(e) => setNombre(e.target.value)}
              />
            </Col>
            <Col md={6}>
              <Label>SKU</Label>
              <Input
                type="text"
                placeholder="Se genera solo con Nombre + Medida"
                value={SKU}
                onChange={(e) => {
                  setSkuManual(true);
                  setSKU(e.target.value);
                }}
              />
              <small style={{ color: "#64748b", fontSize: "0.72rem" }}>
                {skuManual ? (
                  <>
                    Capturado a mano.{" "}
                    <a
                      href="#!"
                      onClick={(e) => {
                        e.preventDefault();
                        setSkuManual(false);
                      }}
                    >
                      Volver a generarlo automático
                    </a>
                  </>
                ) : (
                  "Automático: KIT + 3 letras del nombre + medida. Puedes sobreescribirlo."
                )}
              </small>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={3}>
              <Label>MLM</Label>
              <Input
                type="text"
                placeholder="MLM"
                value={MLM}
                onChange={(e) => setMLM(e.target.value)}
              />
            </Col>
            <Col md={3}>
              <Label>Medida</Label>
              <Input
                type="text"
                placeholder="NA"
                value={medida}
                onChange={(e) => setMedida(e.target.value)}
              />
            </Col>
            <Col md={3}>
              <Label>Precio de venta</Label>
              <Input
                type="number"
                min="0"
                step="any"
                value={venta}
                onChange={(e) => setVenta(e.target.value)}
              />
            </Col>
            <Col md={3}>
              <Label>Observaciones</Label>
              <Input
                type="text"
                value={observaciones}
                onChange={(e) => setObservaciones(e.target.value)}
              />
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={6}>
              <Label>Línea *</Label>
              <Input
                type="select"
                value={selectedLinea}
                required
                onChange={(e) => setSelectedLinea(e.target.value)}
              >
                <option value="">Selecciona línea</option>
                {lineas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((l) => (
                    <option value={l._id} key={l._id}>
                      {l.name}
                    </option>
                  ))}
              </Input>
            </Col>
            <Col md={6}>
              <Label>Marca *</Label>
              <Input
                type="select"
                value={selectedMarca}
                required
                onChange={(e) => setSelectedMarca(e.target.value)}
              >
                <option value="">Selecciona marca</option>
                {marcas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((m) => (
                    <option value={m._id} key={m._id}>
                      {m.name}
                    </option>
                  ))}
              </Input>
            </Col>
          </Row>

          <br />
          <h5>Armado inicial (opcional)</h5>
          <small style={{ color: "#64748b" }}>
            Si capturas almacén y cantidad, al guardar se descuentan los
            componentes y el kit entra al inventario. Puedes dejarlo en 0 y
            armarlo después.
          </small>
          <br />
          <br />
          <Row>
            <Col md={6}>
              <Label>Almacén</Label>
              <Input
                type="select"
                value={selectedArea}
                onChange={(e) => setSelectedArea(e.target.value)}
              >
                <option value="">No armar todavía</option>
                {areas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => (
                    <option value={a._id} key={a._id}>
                      {a.name}
                    </option>
                  ))}
              </Input>
            </Col>
            <Col md={3}>
              <Label>Kits a armar</Label>
              <Input
                type="number"
                min="0"
                step="any"
                value={cantidadArmar}
                onChange={(e) => setCantidadArmar(e.target.value)}
              />
            </Col>
          </Row>

          <br />
          <h5>Componentes del kit</h5>
          <small style={{ color: "#64748b" }}>
            Cuántas unidades de cada artículo lleva UN kit. Puedes agregar los
            que necesites.
          </small>
          <br />
          <br />

          <Table size="sm" borderless>
            <thead>
              <tr>
                <th style={{ width: "70%" }}>Artículo</th>
                <th style={{ width: "20%" }}>Cantidad por kit</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {inputFields.map((f) => (
                <tr key={f.id}>
                  <td>
                    <Autocomplete
                      size="small"
                      value={f.articulo}
                      onChange={(event, sel) => handleChangeArticulo(f.id, sel)}
                      options={opciones}
                      getOptionLabel={(option) => option.junta || ""}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Selecciona"
                          variant="outlined"
                        />
                      )}
                      renderOption={(option) => (
                        <React.Fragment>
                          {option.SKU} {option.nombre}
                        </React.Fragment>
                      )}
                    />
                  </td>
                  <td>
                    <Input
                      type="number"
                      min="0"
                      step="any"
                      value={f.cantidad}
                      onChange={(e) =>
                        handleChangeCantidad(f.id, e.target.value)
                      }
                    />
                  </td>
                  <td>
                    <Button
                      size="sm"
                      color="danger"
                      disabled={inputFields.length === 1}
                      onClick={() => handleRemoveFields(f.id)}
                      tabIndex="-1"
                    >
                      <i className="fas fa-minus"></i>
                    </Button>{" "}
                    <Button size="sm" color="info" onClick={handleAddFields}>
                      <i className="fas fa-plus"></i>
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          <br />
          <Row>
            <Col md={2}>
              <Button
                className="btn btn-success"
                onClick={saveKit}
                disabled={!validaBoton}
              >
                Guardar
              </Button>
            </Col>
            <Col md={2}>
              <Button color="danger" href="/ComponentesKit">
                Regresar
              </Button>
            </Col>
          </Row>
          <br />
        </div>
      ) : undefined}
    </>
  );
}

export default ArticulosKitCreate;
